<template>
	<div class="knd-achtergrond" :class="className">
		<div class="knd-paragraaf">
			<h2 class="knd-h2" v-if="data.titel">{{ data.titel }}</h2>
			<div class="knd-paragraaf-max">
				<div v-html="data.tekst"></div>

			<div class="knd-uitklap-btn" @click="toggleShowing" v-if="data.uitklap">
				<div class="" :class="{'open': isShowing}">
					<svg class="uitklap-icon" width="40" height="39" viewBox="0 0 40 39" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M20 36.5625C10.335 36.5625 2.5 28.9234 2.5 19.5C2.5 10.0766 10.335 2.4375 20 2.4375C29.665 2.4375 37.5 10.0766 37.5 19.5C37.5 28.9234 29.665 36.5625 20 36.5625ZM20 39C31.0457 39 40 30.2696 40 19.5C40 8.73045 31.0457 0 20 0C8.95431 0 0 8.73045 0 19.5C0 30.2696 8.95431 39 20 39Z" fill="#4E243F"></path>
						<path d="M11.6161 11.3257C12.1043 10.8498 12.8957 10.8498 13.3839 11.3257L20 17.7764L26.6161 11.3257C27.1043 10.8498 27.8957 10.8498 28.3839 11.3257C28.872 11.8017 28.872 12.5733 28.3839 13.0493L21.7678 19.5L28.3839 25.9507C28.872 26.4267 28.872 27.1983 28.3839 27.6743C27.8957 28.1502 27.1043 28.1502 26.6161 27.6743L20 21.2236L13.3839 27.6743C12.8957 28.1502 12.1043 28.1502 11.6161 27.6743C11.128 27.1983 11.128 26.4267 11.6161 25.9507L18.2322 19.5L11.6161 13.0493C11.128 12.5733 11.128 11.8017 11.6161 11.3257Z" fill="#4E243F"></path>
					</svg>				
				</div>
				<span class="knd-uitklap-label">{{ data.label || 'toon meer' }}</span>
			</div>

			<Collapse :when="isShowing"> 
				<div class="knd-uitklap">
					<div v-html="data.uitklap"></div>
				</div>
			</Collapse>

		</div>
		</div>
	</div>
</template>

<script>
// import TransitionExpand from '@/components/paragraaf/achtergrond/TransitionExpand.vue';
import { Collapse } from 'vue-collapsed'

export default {
	name: 'App',
  props: ['data'],
	components:{Collapse},
	data() {
		return {
			isShowing: false,
			className: this.data.className || ''
		}
	},
	mounted: function() {
	},
	methods: {
		toggleShowing() {
			this.isShowing = !this.isShowing;
		}
	}
}
</script>


<style lang="scss">

.knd-achtergrond {
	text-align: center;
	background: var(--achtergrond-background)	;
	color: var(--achtergrond-color);
	position: relative;

	&.outro {
		background: var(--intro-background);
		color: var(--colofon-color);
	}

	.knd-h2 {
		color: $jade;
	}


	&.cta {
		background: #4E243F;

		.knd-paragraaf {
			// background: #F4FFE7;
			margin: 5vw;
			border-radius: var(--stepper-border-radius);
			display: inline-flex;
			padding: var(--stepper-padding);
			min-width: 300px;
			max-width: 550px;
			width: var(--stepper-card-width);
	
			box-shadow: 0px 0px 40px #00DEB2;
			color: var(--achtergrond-background);
			// border-radius: 25px;
	
		}
	}
}




.open {
	.uitklap-icon  {
		transform: rotate(0deg) scale(.8) !important;
	}
}


	.knd-uitklap-btn {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 75vw;
    max-width: 300px;
    margin: 2em auto 0;
    padding: 1em;
    color: #4E243F;
    background-color: $jade;
    border: none;
    border-radius: 50px;
		opacity: .8;
		transition: opacity .2s ease-in;
		cursor: pointer;

		.uitklap-icon {
			transform: rotate(-45deg) scale(.8);
			transition-duration: 0.3s;
			transition-property: transform;
			transition-delay: .1s;
		}

		.knd-uitklap-label {
			user-select: none;
		}

		&:hover {
			opacity: 1;
			
			.uitklap-icon {
				// transform: rotate(0deg) scale(1.1);
			}
		}
	}

.knd-uitklap-label {
	margin-top: .5em;
}

	.knd-uitklap {
		// opacity: 0;
		text-align: left;
		// max-height: 0;
		margin: 2em 0;
	
	}

	.expand-enter-active,
.expand-leave-active {
  transition-property: opacity, height;
}

.expand-enter,
.expand-leave-to {
  opacity: 0;
}


</style>